import FormFieldViewCode from "components/FormFields/ViewCode";
import FormFieldViewText from "components/FormFields/ViewText";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerFooter from "ds/components/Drawer/Footer";
import DrawerFooterActions from "ds/components/Drawer/FooterActions";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCancelButton from "ds/components/DrawerNew/CancelButton";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import useTypedFlags from "hooks/useTypedFlags";
import { IntentResource } from "types/generated";

type IntentProjectResourceDetailsDrawerProps = {
  resource: IntentResource;
};

const IntentProjectResourceDetailsDrawer = createDrawer(
  ({ resource }: IntentProjectResourceDetailsDrawerProps) => {
    const { intentToIac } = useTypedFlags();

    return (
      <DrawerSimple>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Resource details" />
          <DrawerCloseIcon />
        </DrawerHeader>
        <DrawerBody gap="x-large" fullHeight>
          <FormFieldViewText label="Resource ID" value={resource.resourceID} withCopy noMargin />
          <FormFieldViewText
            label="Resource type"
            value={resource.resourceType}
            withCopy
            noMargin
          />
          <FormFieldViewText label="Provider" value={resource.provider} withCopy noMargin />
          <FormFieldViewCode
            label="State"
            code={
              resource.state && resource.state !== "null" ? resource.state : "Not available"
            }
            noMargin
          />
          {intentToIac && <FormFieldViewCode label="HCL" code={resource.hcl} noMargin />}
        </DrawerBody>

        <DrawerFooter>
          <DrawerFooterActions>
            <DrawerCancelButton text="Close" />
          </DrawerFooterActions>
        </DrawerFooter>
      </DrawerSimple>
    );
  }
);

export const showIntentProjectResourceDetailsDrawer = createDrawerTrigger(
  IntentProjectResourceDetailsDrawer
);
